module.exports = __webpack_public_path__ + "img/bgs2.7b926fd9.png";